
<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <div class="friendlist">
        
        <!-- 聊天列表  -->
        <div class="lists" v-show="selectIndex==1" v-loading="cloading" element-loading-spinner="el-icon-loading">
            <el-scrollbar style="height: 100%;" ref='scrollbar' v-show="chatlist.records!=undefined&&chatlist.records.length != 0">
                <ul>
                    <li :class="{ top: item.top, active:selectfriendids.wechatContactinfo.friendid==item.friendid && selectfriendids.wechatContactinfo.wechatid==item.wechatid}" @click='showchat(item.friendid,item.wechatid,item.outsideCustomerId)'
                        v-for="item in chatlist.records" :key='item.id' @contextmenu.prevent="e => changetop(e,item.id,item.top)">
                        <div class="friendavatar">
                            <img :src="item.avatar ? item.avatar:'/static/img/defaluttx.png'" alt="" :onerror="errorImg">
                            <img v-if="item.friendDel" class="icon_js" src="/static/img/icon_js.png" alt="">
                        </div>

                        <i v-if="item.unReadCount">{{item.unReadCount | relunReadCount}}</i>
                        <div class="fl">
                            <div class="name textEllipsis">{{item.remark ? item.remark + ' - ' :''}}{{item.nickname}}</div>
                            <div v-if="item.contentType == '1' || item.contentType == '101'" class="shotcon textEllipsis" v-html="$options.filters.realcontent(item.content)"></div>
                            <div v-else-if="item.contentType == '2'" class="shotcon textEllipsis">[图片]</div>
                            <div v-else-if="item.contentType == '3'" class="shotcon textEllipsis">[语音]</div>
                            <div v-else-if="item.contentType == '4'" class="shotcon textEllipsis">[视频]</div>
                            <div v-else-if="item.contentType == '5'" class="shotcon textEllipsis">[系统消息]</div>
                            <div v-else-if="item.contentType == '6'" class="shotcon textEllipsis">[扩展链接]</div>
                            <div v-else-if="item.contentType == '8'" class="shotcon textEllipsis">[文件]</div>
                            <div v-else-if="item.contentType == '9'" class="shotcon textEllipsis">[名片]</div>
                            <div v-else-if="item.contentType == '10'" class="shotcon textEllipsis">[位置信息]</div>
                            <div v-else-if="item.contentType == '11'" class="shotcon textEllipsis">[红包]</div>
                            <div v-else-if="item.contentType == '12'" class="shotcon textEllipsis">[转账]</div>
                            <div v-else-if="item.contentType == '14'" class="shotcon textEllipsis">[表情]</div>
                            <div v-else-if="item.contentType == '15'" class="shotcon textEllipsis">[不支持的消息类型]</div>
                            <div v-else-if="item.contentType == '16'" class="shotcon textEllipsis">[领取红包消息]</div>
                            <div v-else-if="item.contentType == '18'" class="shotcon textEllipsis">[分享链接]</div>
                            <div v-else-if="item.contentType == '19'" class="shotcon textEllipsis">[语音通话]</div>
                            <div v-else-if="item.contentType == '20'" class="shotcon textEllipsis">[视频通话]</div>
                            <div v-else-if="item.contentType == undefined" class="shotcon textEllipsis"></div>
                            <div v-else class="shotcon textEllipsis">[不支持的消息类型]</div>
                            <!-- <div v-else-if="item.contentType == undefined" class="shotcon textEllipsis">[不支持的消息类型]</div> -->
                        </div>
                        <div class="fr">
                            {{item.contactTime|timeformat}}
                        </div>
                    </li>
                </ul>
            </el-scrollbar>
            <p class="noresult" v-show="chatlist.records ==undefined || chatlist.records.length == 0">暂无聊天</p>


        </div>

        <!-- 好友列表 -->
        <div class="lists" v-show="selectIndex==2">

            <p v-show="newfriendlist.records!=undefined&&newfriendlist.records.length != 0">共{{newfriendlist.total}}位联系人</p>

            <!--  -->
            <div class="friendbox" v-show="newfriendlist.records!=undefined&& newfriendlist.total != 0">
                <el-scrollbar style="height: 100%;" ref='fscrollbar' v-loading="floading" element-loading-spinner="el-icon-loading">
                    <!-- v-for="firstsort in sort" :key='firstsort' -->
                    <div class="listSrot" v-for="(val,ind) in newfriendlist.records" :key='ind'>
                        <p>{{val.py}}</p>
                        <ul>
                            <li :class="{active:choosefriend.fid==item.friendid && choosefriend.wid==item.wechatid}" v-for="(item,index) in val.lists" :key='index'
                                @click="selectfriend(item.id,item.friendid,item.wechatid)">
                                <div class="friendavatar">
                                    <img :src="item.avatar ? item.avatar:'/static/img/defaluttx.png'" alt="" :onerror="errorImg">
                                    <img v-if="item.friendDel" class="icon_js" src="/static/img/icon_js.png" alt="">
                                </div>
                                <div class="fl">
                                    <div class="name textEllipsis">{{item.remark ? item.remark + ' - ' :''}}{{item.nickname}}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-scrollbar>
            </div>
            <p class="noresult" v-show="newfriendlist.records ==undefined ||newfriendlist.records.length == 0">暂无好友</p>
        </div>

        <!-- 搜索列表 -->
        <div class="lists searchlists" v-show="selectIndex==3">
            <el-scrollbar class="tipcon"  ref='searchbar' style="height: calc(100% - 88px)" v-show='searchlist !=""'>
                <ul>
                    <li :class="{active:selectfriendids.wechatContactinfo.friendid==item.friendid&&selectfriendids.wechatContactinfo.wechatid==item.wechatid}" v-for="(item,index) in searchlist.data.records"
                        :key='index' @click="searfriendsel(item)">
                        <div class="friendavatar"  v-if="index <= 4 || showall">
                            <img :src="item.avatar ? item.avatar:'/static/img/defaluttx.png'" alt="" :onerror="errorImg">
                            <img v-if="item.friendDel" class="icon_js" src="/static/img/icon_js.png" alt="">
                        </div>
                        <div class="fl"  v-if="index <= 4 || showall">
                            <div class="name textEllipsis">{{item.remark ? item.remark + ' - ' :''}}{{item.nickname}}</div>
                        </div>
                    </li>
                </ul>
                <p class="noresult" v-show='searchlist.data.total ==0 || searchlist.data.records==undefined'>
                    <span v-if="searchlist.searchtxt">无“{{searchlist.searchtxt}}”的相关信息</span>
                    <span v-else>暂无信息</span>
                </p>
            </el-scrollbar>
            <div class="bot_btn">
                <div class="btnlist showmoare">
                    <span @click="showalllist(false)" v-if="searchlist.data.records && searchlist.data.records.length>5 && !showall">显示全部({{searchlist.data.total}})</span>
                    <span @click="showalllist(true)" v-if="searchlist.data.records && searchlist.data.records.length>5 && showall">收起</span>
                </div>
                <div class="btnlist search_btn" @click="searchhistory">
                    <i class="iconfont">&#xe7ce;</i>搜索聊天记录
                </div>
            </div>
        </div>

        <searchchathistory :searchdata="showsearchdialog" @closesearchhistory="closesearchhistory"></searchchathistory>

        <!-- 置顶 -->
        <div v-show="menuVisible">
            <ul id="menu" class="menu">
                <li class="menu_item" @click="changechattop">{{ topdata.istop ? '取消置顶' : '置顶'}}</li>
                <li class="menu_item" @click="deletechat">移除会话</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from 'vuex'
    import {
        chatSessionList,
        chatFriendList,
        checkWeChatMsg,
        findHistoryWechatMessage,
        friendInfo,
        findWechatAndFriend,
        setChatSession
    } from '@/utils/api-im.js'
    import searchchathistory from './searchchathistory'
    export default {
        name: "MyList",
        data() {
            return {
                chatid: '', //选中聊天index
                choosefriend: '', //选中好友的id
                choosesearch: '', //选中搜索
                isneedtofrist: false, //是否需要置顶好友
                chatfrienfinfo: '', //聊天好友的信息
                outfriendid: '', //外部好友id
                outwechatid:'',//外部设备id
                newfriendlist: {},
                friendarr: [],
                weChatNiceName: '',
                wechatAvatar: '',
                flag: true,
                chatflag: true,
                floading: false,
                sloading: false,
                fpage: 1,
                cpage: 1,
                spage: 1,
                errorImg: "this.src='/static/img/defaluttx.png'",
                errornum :true,
                showsearchdialog:false,
                showall:false,
                cloading:false,//加载会话loading
                topdata: {
                    istop: false,
                    id: ''
                },
                menuVisible: false,
                chatlisttop: {
                    records: []
                }
            }
        },
        components:{
            searchchathistory
        },
        props: {
            selectIndex: {
                default: 1
            },
            issearch: {
                type: Number,
                default: 0 //0不是搜索 1 搜索
            },
            newremarkinfo: {},
            searchdata:{
                type: Object,
                default: {} //0不是搜索 1 搜索
            }
        },
        filters: {
            timeformat(t) {
                if (t == '' || t == undefined) {
                    return ''
                }
                if (typeof t === 'string') {
                    t = t.replace(/-/g, '/')
                }
                let day = new Date(),
                    fday = new Date(t),
                    month = fday.getMonth() + 1,
                    h = fday.getHours(),
                    m = fday.getMinutes();
                month = month >= 10 ? month : '0' + month
                m = m >=10 ? m: '0'+m
                return t = day.toLocaleDateString() == fday.toLocaleDateString() ? h + ':' + m : month + '-' + fday.getDate()
            },
            relunReadCount(n){
                let num = ''
                if(n){
                    if(n>99){
                        num = '99+'
                    }else{
                        num = n
                    }
                }else{
                    num = n
                }
                return num
            }
        },
        computed: {
            ...mapGetters('im', [
                'searchlist',
                'selectfriendids',
                'selTeam',
                'chatlist',
                'friendlist',
                'getdocumentarybutton',
                'rightbtn'
            ])
        },
        watch: {
            newremarkinfo() {
                for (let i = 0; i < this.newfriendlist.records.length; i++) {
                    for (let j = 0; j < this.newfriendlist.records[i].lists.length; j++) {
                        if (this.newfriendlist.records[i].lists[j].friendid == this.newremarkinfo.friendid && this.newfriendlist.records[i].lists[j].wechatid == this.newremarkinfo.wechatid) {
                            this.newfriendlist.records[i].lists[j].remark = this.newremarkinfo.remark
                        }
                    }
                }
            },
            'searchdata.isnew'(){
                this.spage = 2
                this.showall = false
                this.sloading = false
            },
            'selTeam.activeindex' (){
                console.log('6666')
                this.cloading = true
                setTimeout(() => {
                    this.fpage = 1
                    this.cpage = 1
                    this.spage = 1
                    this.SELECTCHAT({
                        records:[]
                    })
                    //拉取列表数据
                    this.getlist(true)
                }, 500);
            },
            selectIndex(){
                this.fpage = 1
                this.cpage = 1
                this.spage = 1
                this.SELECTCHAT({
                    records:[]
                })
                //拉取列表数据
                this.getlist(true)
            },
            rightbtn(){
                this.menuVisible = false
            }
        },
        mounted() {
            
            if (this.chatlist.records.length != 0) {
                //读取vuex中会话列表，有数据则阻断刷新重新发起的请求
                let list = [...this.chatlist.records]
                // list = list.filter(v => !v.top)
                this.cpage = Math.floor(list.length / 50)
                this.chatflag = sessionStorage.getItem('chatflag') == 'false' ? false : true
            } else {
                console.log('mounted1111')
                this.cpage = 1
                this.chatflag = true
            }
           
            // console.log(dd,'sddddd322323')
            //拉取列表数据
            this.getlist()
            //直接从路由带入friendid则直接打开与该好友聊天窗口
            this.opennewchat();
            //滚动条
            this.flag = true;
            console.log(this.selectfriendids,'selectfriendidsselectfriendids')
        },
        methods: {
            ...mapMutations('im', [
                'SETDOCBTN',
                'SETCANSEND',
                'SEARCHINFO',
                'SELECTFRIEND',
                'SELECTCHAT',
                'MSGID',
                'CLOSERIGHT'
            ]),

            searchhistory(){
                this.showsearchdialog = true
            },

            searfriendsel(item){
                if(this.searchdata.seltype == 'chat'){
                    this.showchat(item.friendid,item.wechatid,item.outsideCustomerId,true,item)
                }else{
                    this.selectfriend(item.id,item.friendid,item.wechatid)
                }
            },

            closesearchhistory(){
                this.showsearchdialog = false
            },

            // 置顶
            changetop(MouseEvent,id,top) {
                // 通过id和置顶状态
                this.topdata = {
                    istop: top,
                    id: id
                }
                console.log(0)
                this.CLOSERIGHT(Math.random())
                setTimeout(() => {
                    this.menuVisible = true  // 显示模态窗口，跳出自定义菜单栏
                }, 50);
                console.log(this.menuVisible)
                var menu = document.querySelector('#menu')
                document.addEventListener('click', this.removeclick) // 给整个document添加监听鼠标事件，点击任何位置执行
                menu.style.display = "block";
                menu.style.left = MouseEvent.clientX +10 + 'px'
                menu.style.top = MouseEvent.clientY + 'px'
            },
            removeclick() { // 取消鼠标监听事件 菜单栏
                this.menuVisible = false
                document.removeEventListener('click', this.foo) // 关掉监听
            },
            // 改变置顶状态
            changechattop() {
                let operateType = ""
                if (!this.topdata.istop){
                    operateType = "setTop"
                } else {
                    operateType = "cancelTop"
                }
                this.$post(setChatSession, {
                    operateType: operateType,
                    wechatContactinfoId: this.topdata.id
                }).then(res => {
                    let listdata = {...this.chatlist}
                    if(res.data.code === 200){
                        if (operateType === "setTop"){
                        //删除当前选中会话，刷新指定列表
                            let newdata = listdata.records.filter(v => this.topdata.id !== v.id )
                            listdata.records = newdata
                            this.SELECTCHAT(listdata)
                            this.getchatlisttop()
                        } else {
                            this.chatflag = true
                            this.cpage = 1
                            this.getchatlist(undefined,true)
                        }
                    }else{
                        this.$toast(res.data.msg);
                    }
                })
            },
            // 删除会话
            deletechat() {
                this.$post(setChatSession, {
                    operateType: "del",
                    wechatContactinfoId: this.topdata.id
                }).then(res => {
                    if(res.data.code === 200){
                        let listdata = {...this.chatlist}
                        let newdata = listdata.records.filter(v => this.topdata.id !== v.id )
                        listdata.records = newdata
                        this.SELECTCHAT(listdata)
                    }else{
                        this.$toast(res.data.msg);
                    }
                })
            },

            showalllist(bool){
                this.showall = !bool
                this.sloading = true
                this.getsearchlist()
            },

            getlist(bool) {
                if(this.$route.query.friendid == 'false'){
                    return false
                }
                if (this.selectIndex == 1) {
                    if(bool){
                        this.SELECTCHAT({
                            records:[]
                        })
                        this.chatflag = true
                        this.getchatlisttop(true)
                        return false
                    }
                    if (this.chatlist.records == undefined || this.chatlist.records.length == 0) {
                        // 指定会话
                        this.getchatlisttop(true)
                        // this.getchatlist()
                    }
                }
                if (this.selectIndex == 2) {
                    if(bool){
                        this.newfriendlist = {}
                        this.friendarr = []
                        this.flag =true
                        this.getfriendslist()
                        return false
                    }
                    if (this.friendlist.records == undefined || this.friendlist.records.length == 0) {
                        this.getfriendslist()
                    }
                }
            },

            opennewchat() {
                if (this.$route.params.friendid != undefined && this.$route.query.friendid != 'false' && this.$route.params
                    .type == 1) {
                    //从好友详情进入的直接开始会话
                    // this.chatfrienfinfo = this.$route.params
                    let {
                        friendid,
                        wechatid,
                        outsideCustomerId
                    } = this.$route.params;
                    this.showchat(friendid, wechatid, outsideCustomerId,true)
                    
                }
                if (this.$route.query.friendid != undefined && this.$route.query.friendid != 'false') {
                    //从外部传入好友id进入的获取到好友信息再开始会话
                    this.outfriendid = this.$route.query.friendid
                    this.outwechatid = this.$route.query.wechatid
                    if (this.outfriendid != this.selectfriendids.wechatContactinfo.friendid) {
                        this.chatflag = true
                        this.SELECTCHAT({
                            records:[]
                        })
                        this.cpage = 1
                        console.log(this.chatlist,'opennewchat2')
                        this.getchatlisttop(true)
                        // this.getchatlist()
                    }
                }
            },

            showchat(fid, wid, outsideCustomerId, bool,obj) {
                //fid, wid, imgurl, nickname, remark,为好友信息 bool用来区分是否是会话窗口点击的开始聊天
                //判断outsideCustomerId显示右侧跟单
                outsideCustomerId ? this.SETDOCBTN(true) : this.SETDOCBTN(false)
                //选中会话对象
                this.isneedtofrist = bool ? true : false;
                //打开跟单列表
                const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(255, 255, 255, 0)'
                });

                let friendmsg = {
                    friendid:fid,
                    wechatid:wid,
                    outsideCustomerId:outsideCustomerId
                }

                //向开始聊天接口验证
                this.$post(checkWeChatMsg, {
                    friendid: fid,
                    wechatid: wid
                }).then(res => {
                    let isr = true
                    loading.close()
                    // this.findWechatAndFriend(fid,wid)
                    
                    if(obj){
                        this.chatfrienfinfo = obj
                    }
                    this.$emit("toselindex",1)
                    this.addnewchat(fid,wid)
                    if (res.data.code == 200) {
                        console.log(res.data.data,'res.data.hasFriendAuthority')

                        if(res.data.data.hasFriendAuthority){
                            this.SETCANSEND(1)
                            //如果在好友列表，切换到会话窗口
                            if (this.selectIndex == 3) {
                                this.$router.push({
                                    name: 'chat'
                                })
                            }
                            //消息标记已读
                            this.msgstate(fid,wid)
                        }else{
                            isr = false
                            this.SETCANSEND(2)
                            this.$toast('没有权限聊天');
                        }
                        // 重置聊天记录
                        this.SELECTFRIEND({
                            sysWechatAccount: res.data.data.sysWechatAccount,
                            wechatContactinfo: res.data.data.wechatContactinfo,
                            wechatMessage: {
                                lastmsgid: 0,
                                data: []
                            }
                        })
                        //拉取最近的聊天记录,更新会话信息
                        this.getchatlist({
                            sysWechatAccount: res.data.data.sysWechatAccount,
                            wechatContactinfo: res.data.data.wechatContactinfo,
                        })
                    } else {
                        if(res.data.msg == "没有权限聊天"){
                            isr = false
                        }
                        this.SETCANSEND(2)
                        this.$toast(res.data.msg);
                    }

                    if(isr){
                        let initBusType = localStorage.getItem('initBusType')
                        if (initBusType == 'INNER_CRM') {
                            window.parent.postMessage({
                                type: 'open',
                                outsideCustomerId: outsideCustomerId,
                                friendid: fid
                            }, '*')
                        } else {
                            if (outsideCustomerId) {
                                this.$nextTick(() => {
                                    let token = localStorage.getItem('initToken')
                                    let domainConfig = localStorage.getItem('userInfo')
                                    domainConfig = JSON.parse(domainConfig).domainConfig.crmDomain
                                    let host =window.location.href;
                                    if(host.indexOf('https://')!=-1){
                                      domainConfig =  domainConfig.replace('http://','https://')
                                    }
                                    let iframeurl =
                                        domainConfig+'/imCustomerTrack/customerDetailPanel?imCustomerId=' +
                                        outsideCustomerId + '&authToken=' + token + '&friendid=' + fid
                                    //let iframeurl = 'http://172.16.4.154/imCustomerTrack/customerDetailPanel?imCustomerId=5dc52e4d4ad9ae000dfd1973&authToken=fb6171a12e424646bbf6bf02f57c732f'
                                    //
                                    sessionStorage.setItem('iframeurl', JSON.stringify({
                                        iframeurl: iframeurl,
                                        friendid: fid
                                    }))
                                    $('.frame').attr('src', iframeurl)

                                })

                            }
                        }
                    }
                }).catch(res => {
                    //this.$message.error(res);
                })
            },

            getHistoryWechatMessage(msg) {
                
                let friendid = msg.wechatContactinfo.friendid
                let wechatid = msg.wechatContactinfo.wechatid
                console.log(friendid,wechatid,'msg')
                //拉取最近聊天记录
                this.$post(findHistoryWechatMessage, {
                    friendid,
                    wechatid
                }).then(res => {
                    //清除离线未读消息
                    if(res.data.code === 200){

                        let msgdata = res.data.data
                        let lastid = msgdata.length==0 ?'': msgdata[0].id
                        const token = localStorage.getItem('token')
                        this.socketApi.sendSock({
                            msgType: "WEB_CLEAR_UNREAD_REQ",
                            msgContent: {
                                weChatId: wechatid,
                                friendId: friendid,
                                token:token
                            }
                        })
                        //更新聊天窗口数据
                        this.SELECTFRIEND({
                            sysWechatAccount: msg.sysWechatAccount,
                            wechatContactinfo: msg.wechatContactinfo,
                            wechatMessage: {
                                wxSendTime: '',
                                data: msgdata.reverse()
                            }
                        })
                        this.MSGID(Math.random())
                        if(msgdata && msgdata.length!=0){

                            let olddata = this.chatlist;
                            for (let i = 0; i < olddata.records.length; i++) {
                                for(let j = 0; j<msgdata.length;j++){
                                    if (olddata.records[i].friendid == friendid && msgdata[j].isSend == "false" && olddata.records[i].wechatid == wechatid) {
                                        olddata.records[i].remark = msgdata[j].remark
                                        olddata.records[i].unReadCount = 0
                                        this.SELECTCHAT(olddata)
                                        return false
                                    }
                                }

                            }

                        }
                       
                    }
                }).catch(res => {
                    //this.$message.error(res);
                })
            },

            getchatlist(msg,bool,obj) {
                //获取or更新-会话列表
                if (msg != undefined) {
                    this.getHistoryWechatMessage(msg)
                } else {
                    if (this.chatflag) {
                        this.chatflag = false;
                        sessionStorage.setItem('chatflag', this.chatflag)
                        this.$post(chatSessionList, {
                            current: this.cpage,
                            size: 50,
                            queryChatSessionType: 2,
                            queryListGroupType:this.selTeam.type,
                            wechatid:this.selTeam.id
                        }).then(res => {
                            if (res.data.code == 200) {
                                if(bool){
                                    // 置顶操作
                                    let listdata = {...this.chatlist}
                                    let newdata = listdata.records.filter(v => v.top && v.id !== this.topdata.id  )
                                    listdata.records = newdata
                                    this.SELECTCHAT(listdata)
                                }
                                if(this.cpage == 1){
                                    let div = this.$refs['scrollbar'].$refs['wrap'];
                                    console.log('div',div,div.scrollTop)
                                    setTimeout(() => {
                                        div.scrollTop = 0
                                    }, 10);
                                }
                                
                                //收到10条数据显示加载更多
                                if (res.data.data.records.length == 50) {
                                    setTimeout(() => {
                                        this.chatflag = true
                                        sessionStorage.setItem('chatflag', this.chatflag)
                                        this.cpage++;
                                    }, 500)
                                }
                                
                                if (this.chatlist.records.length == 0) {
                                    
                                    if (obj!=undefined){
                                        let newchatdata = res.data.data.records
                                        let oldchatdata = obj
                                        oldchatdata.records = oldchatdata.records.concat(newchatdata)
                                        this.SELECTCHAT(oldchatdata)
                                        
                                    }else{
                                        this.SELECTCHAT(res.data.data)
                                    }
                                } else {
                                    let newchatdata = res.data.data.records
                                    let oldchatdata = this.chatlist
                                    oldchatdata.records = oldchatdata.records.concat(newchatdata)
                                    //列表去重

                                    let resultArr = [];
                                    let count;
                                    for (let i = 0; i < oldchatdata.records.length; i++) {
                                        count = 0;
                                        for (let j = 0; j < resultArr.length; j++) {
                                            if (resultArr[j].friendid == oldchatdata.records[i].friendid&&resultArr[j].wechatid ==oldchatdata.records[i].wechatid) {
                                                count++;
                                                break;
                                            }
                                        }
                                        if (count == 0) {
                                            resultArr[resultArr.length] = oldchatdata.records[i];
                                        }
                                    }
                                    oldchatdata.records = []
                                    oldchatdata.records = resultArr
                                    this.SELECTCHAT(oldchatdata)
                                }
                                // 关闭loading
                                this.cloading = false
                                if (this.outfriendid != '') {
                                    //获取好友信息
                                    this.$post(chatFriendList, {
                                        friendid: this.outfriendid,
                                        wechatid:this.outwechatid,
                                        queryChatSessionType:3
                                    }).then(res => {
                                        if (res.status == 200) {
                                            this.outfriendid = ''
                                            if (res.data.data.records.length == 0 && this.errornum) {
                                                this.errornum =false
                                                this.$toast('查不到此好友！')
                                                setTimeout(()=>{
                                                    this.errornum = true
                                                },1500)
                                                return false
                                            }

                                            this.chatfrienfinfo = res.data.data.records[0]
                                            let {
                                                friendid,
                                                content,
                                                contentType,
                                                createTime,
                                                friendWechatno,
                                                wechatid,
                                                avatar,
                                                nickname,
                                                remark,
                                                outsideCustomerId
                                            } = res.data.data.records[0]
                                            this.showchat(friendid, wechatid, outsideCustomerId,true)
                                        } else {
                                            this.$toast(res.data.msg);
                                        }
                                    }).catch(res => {
                                        //this.$message.error(res);
                                    })
                                }
                                let _this = this;
                                let div = this.$refs['scrollbar'].$refs['wrap'];
                                // if (div.scrollTop == div.scrollHeight - div.offsetHeight) {
                                //     setTimeout(() => {
                                //         _this.getchatlist()
                                //     }, 500)
                                // }
                                div.addEventListener('scroll', () => {
                                    this.menuVisible = false
                                    setTimeout(() => {
                                        if (div.scrollHeight - div.offsetHeight - div.scrollTop <= 40 ) {
                                            _this.getchatlist()
                                        }
                                    }, 500)
                                    
                                })

                            } else {
                                this.$toast(res.data.msg);
                            }
                        }).catch(err => {
                            this.$toast(err);
                        })

                    }
                }
            },

            getchatlisttop(bool) {
                if(bool){
                    this.cloading = true
                }
                //获取or更新-会话列表
                this.$post(chatSessionList, {
                    current: 1,
                    size: 50,
                    queryChatSessionType: 1,
                    queryListGroupType:this.selTeam.type,
                    wechatid:this.selTeam.id
                }).then(res => {
                    if (res.data.code == 200) {
                        let newchatdata = res.data.data.records
                        let oldchatdata = {...this.chatlist} 
                        oldchatdata.records = newchatdata.concat(oldchatdata.records)
                        //列表去重

                        let resultArr = [];
                        let count;
                        for (let i = 0; i < oldchatdata.records.length; i++) {
                            count = 0;
                            for (let j = 0; j < resultArr.length; j++) {
                                if (resultArr[j] && oldchatdata.records[i] && resultArr[j].friendid == oldchatdata.records[i].friendid&&resultArr[j].wechatid ==oldchatdata.records[i].wechatid) {
                                    count++;
                                    break;
                                }
                            }
                            if (count == 0) {
                                resultArr[resultArr.length] = oldchatdata.records[i];
                            }
                        }
                        oldchatdata.records = []
                        oldchatdata.records = resultArr
                        if(!bool){
                            this.SELECTCHAT(oldchatdata)
                        }else{
                            this.getchatlist(undefined,false,oldchatdata)
                        }
                    } else {
                        this.$toast(res.data.msg);
                        this.cloading = false; //隐藏loading
                    }
                })
            },

            addnewchat(id,wid) {
                if (!this.isneedtofrist) {
                    return false;
                }
                const oldArr = {...this.chatlist};
                let addtofrist = {};
                let n = null
                let nn = 0
                console.log(oldArr, 'oldArroldArroldArroldArr',id ,wid)
                if (oldArr && oldArr.records.length != 0) {
                    for (var i = 0; i < oldArr.records.length; i++) {
                        if (oldArr.records[i].top) {
                            nn++
                        }
                        if (oldArr.records[i].friendid == id &&oldArr.records[i].wechatid == wid) {
                            addtofrist = {...oldArr.records[i]}
                            n = i
                        }
                    }
                    console.log(addtofrist, 'oldArroldArroldArroldArr',n ,nn)
                    if (JSON.stringify(addtofrist) == '{}') {
                        addtofrist = {...this.chatfrienfinfo}
                    }
                    addtofrist.unReadCount = 0
                    console.log(addtofrist,' addtofristaddtofrist',nn, n)
                    if(n !== null){
                        oldArr.records.splice(n, 1); // 如果数据组存在该元素，则把该元素删除
                    }
                    if(addtofrist.top){
                        oldArr.records.splice(0,0,addtofrist); 
                    }else{
                        oldArr.records.splice(nn,0,addtofrist); // 添加到第nn个位置
                    }
                    console.log(oldArr, 'oldArroldArroldArroldArr22222')
                    this.SELECTCHAT(oldArr)
                } else {
                    
                }
            },

            //未读消息
            msgstate(id) {
                let oldArr = this.chatlist;
                if (oldArr) {
                    for (var i = 0; i < oldArr.records.length; i++) {
                        if (oldArr.records[i].friendid === id) {
                            oldArr.records[i].unReadCount = 0
                            break;
                        }
                    }
                    this.SELECTCHAT(oldArr)
                }
            },

            getfriendslist() {

                if (this.flag) {
                    this.floading = true
                    this.flag = false;
                    //获取好友列表
                    this.$post(chatFriendList, {
                        current: this.fpage,
                        size: 50,
                        queryListGroupType:this.selTeam.type,
                        wechatid:this.selTeam.id
                    }).then(res => {
                        
                        if (res.data.code == 200) {
                            //按字母分类数据
                            let arr = [],
                                newarr = [];
                            if (res.data.data.records.length > 0) {
                                if (this.friendarr.length == 0) {
                                    this.friendarr = res.data.data.records
                                } else {
                                    this.friendarr = this.friendarr.concat(res.data.data.records)
                                    //好友去重
                                    let resultArr = [];
                                    let count;
                                    for (let i = 0; i < this.friendarr.length; i++) {
                                        count = 0;
                                        for (let j = 0; j < resultArr.length; j++) {
                                            if (resultArr[j].friendid == this.friendarr[i].friendid&&resultArr[j].wechatid == this.friendarr[i].wechatid) {
                                                count++;
                                                break;
                                            }
                                        }
                                        if (count == 0) {
                                            resultArr[resultArr.length] = this.friendarr[i];
                                        }
                                    }
                                    this.friendarr = []
                                    this.friendarr = resultArr

                                }
                                if (res.data.data.records.length == 50) {
                                    setTimeout(() => {
                                        this.flag = true
                                        this.fpage++;
                                    }, 300)
                                }
                                for (let i = 0; i < this.friendarr.length; i++) {
                                    if (arr.indexOf(this.friendarr[i].firstPinyin) == -1) {
                                        arr.push(this.friendarr[i].firstPinyin)
                                    }
                                }
                                for (let j = 0; j < arr.length; j++) {
                                    newarr[j] = {
                                        py: arr[j],
                                        lists: []
                                    }
                                }
                                for (let jj = 0; jj < newarr.length; jj++) {
                                    for (let ii = 0; ii < this.friendarr.length; ii++) {
                                        if (newarr[jj].py == this.friendarr[ii].firstPinyin) {
                                            newarr[jj].lists.push(this.friendarr[ii])
                                        }
                                    }
                                }
                                let newdata = res.data.data
                                newdata.records = [...newarr]
                                newdata.total = res.data.data.total
                                console.log(newdata,'newdata')
                                this.newfriendlist = {...newdata}
                                console.log(this.newfriendlist)
                            }
                            let div1 = this.$refs['fscrollbar'].$refs['wrap'];
                            let _this = this;

                            if (div1.scrollTop == div1.scrollHeight - div1.offsetHeight) {
                                setTimeout(() => {
                                    _this.getfriendslist()
                                }, 500);
                            }
                            div1.addEventListener('scroll', () => {
                                this.menuVisible = false
                                if (div1.scrollHeight - div1.offsetHeight - div1.scrollTop  <= 40) {
                                    _this.getfriendslist()
                                }
                            })
                        } else {
                            this.$toast(res.data.msg);
                        }
                        this.floading = false
                    }).catch(err => {
                        this.$toast(err);
                    })
                }
            },

            getsearchlist(){
                if(this.sloading){
                    this.sloading = false
                    const url = this.searchdata.seltype == "chat" ? chatSessionList : chatFriendList
                    const queryChatSessionType = this.searchdata.seltype == "chat" ? 3 : ''
                    this.$post(url, {
                        remark: this.searchdata.remark,
                        friendTags: this.searchdata.friendTags,
                        addWaySource: this.searchdata.addWaySource,
                        friendDel: this.searchdata.friendDel,
                        current:this.spage,
                        queryChatSessionType:queryChatSessionType
                    }).then(res => {
                        if (res.data.code == 200) {
                            let sdate = res.data.data
                            const obj = {...this.searchlist}
                            if(sdate.records.length>0){
                                obj.data.records = obj.data.records.concat(sdate.records)
                                this.SEARCHINFO(obj)
                                console.log(obj,'obj')
                                if(sdate.records.length==10){
                                    setTimeout(res=>{
                                        this.spage++
                                        this.sloading = true
                                    },300)
                                }
                            }
                            let div1 = this.$refs['searchbar'].$refs['wrap'];
                            let _this = this;

                            if (div1.scrollTop == div1.scrollHeight - div1.offsetHeight) {
                                setTimeout(() => {
                                    _this.getsearchlist()
                                }, 500);
                            }
                            div1.addEventListener('scroll', () => {
                                this.menuVisible = false
                                if (div1.scrollHeight - div1.offsetHeight - div1.scrollTop  <= 40) {
                                    _this.getsearchlist()
                                }
                            })
                        } else {
                            this.$toast(res.data.msg);
                        }
                    })
                }
                
            },

            selectfriend(id,fid,wid) {
                // 选择好友列表中的好友
                this.$emit('friendinfo', {
                    id:id,
                    fid:fid,
                    wid:wid
                })
                //关闭跟单
                this.choosefriend = {
                    fid:fid,
                    wid:wid
                }
            },

        },

        destroyed() {

        }
    }
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        scrollbar-arrow-color: red;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
        background: rgba(0, 0, 0, 0.1);
        scrollbar-arrow-color: red;
        display: none;
    }

    ::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        background: transparent;
    }
    // 置顶
    .menu_item {
        line-height: 24px;
        text-align: center;
        height: 24px;
        cursor: pointer;
        font-size: 12px;
    }

    .menu {
        width: 88px;
        position: fixed;
        background-color: #F0F1F2;
        border-radius: 4px;
        overflow: hidden;
        z-index: 99;
        box-shadow:0px 0px 12px 0px rgba(13,18,30,0.1);
    }

    li:hover {
        background-color: #008AFF;
        color: white;
    }
    /* 列表 */
    .lists {
        height: calc(100vh - 126px);
        overflow: hidden;

        &:hover::-webkit-scrollbar-thumb {
            display: block;
        }

        .loading {
            height: 50px;
            background: #fff;
        }

        .friendbox {
            height: calc(100% - 32px);
            // overflow-y: auto;
            // overflow-x: hidden;

            &:hover::-webkit-scrollbar-thumb {
                display: block;
            }
        }

        &>p {
            color: #93999F;
            font-size: 12px;
            padding: 10px 0 10px 20px;
        }

        ul {
            width: 100%;
        }

        li {
            background: #fff;
            cursor: pointer;
            text-align: left;
            position: relative;
            display: flex;
            padding-right: 70px;

            i {
                position: absolute;
                top: 3px;
                left: 44px;
                padding: 2px 0;
                height: 14px;
                text-align: center;
                width: 18px;
                line-height: 14px;
                font-size: 12px;
                border-radius: 9px;
                background: red;
                color: #fff;
            }

            &.top {
                background: #EEEEEE;
            }

            &.active {
                background: #F7F7F7;
            }

            &:hover {
                background: #F6F6F7;
            }

            & .textEllipsis {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .friendavatar {
                height: 40px;
                width: 40px;
                border-radius: 20px;
                float: left;
                margin: 12px 10px 12px 18px;
                position: relative;

                &>img {
                    height: 40px;
                    width: 40px;
                    border-radius: 20px;

                }
                .icon_js{
                    height: 14px;
                    width: 14px;
                    border-radius: 7px;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
            }

            &>.fl {
                min-width: 70px;
            }

            .name {
                font-size: 14px;
                line-height: 18px;
                color: #333;
                margin: 10px 0 4px;
            }

            .shotcon {
                height: 25px;
                font-size: 12px;
                color: #93999f;
                line-height: 22px;
            }

            &>.fr {
                width: 50px;
                height: 18px;
                font-size: 12px;
                color: #B5B9BC;
                line-height: 18px;
                margin: 12px 0 12px;
                padding-right: 17px;
                position: absolute;
                top: 0;
                right: 0;
                text-align: left;
            }
        }

        /* 好友分类 */
        .listSrot {
            border-bottom: 1px solid #E7EBF3;

            &:last-child {
                border: none;
            }

            p {
                text-align: left;
                color: #93999F;
                font-size: 12px;
                line-height: 18px;
                margin-left: 18px;
                padding-top: 20px;
            }

            .name {
                line-height: 40px;
            }
        }

        .tips{
            padding: 0 10px 0 18px;
            height: 120px;
            border-bottom:1px solid #E7EBF3;
            ul{
                padding-right: 17px;
                width: calc(100% - 18px);
            }

            li{
                height: 32px;
                text-align: center;
                line-height: 32px;
                padding: 0 8px;
                background:rgba(236,245,255,1);
                border-radius:2px;
                border:1px solid rgba(224,237,255,1);
                float: left;
                color: #0099FF;
                margin: 0 8px 12px 0;
                cursor: pointer;

                i{
                    color: #0099FF;
                    background: none;
                    height: 32px;
                    width: 30px;
                    text-align: center;
                    line-height: 32px;
                    vertical-align: middle;
                    position: static;
                    padding: 0;
                }
            }
        }

        .btnlist{
            height: 40px;
            line-height: 40px;
            padding: 0 10px;
            cursor: pointer;
            font-size: 14px;

            &.showmoare{
                border-bottom: 1px solid #E7EBF3;
            }

            &.search_btn{
                 i{
                     margin-right: 5px;
                 }
            }
        }

        /* 搜索无结果 */
        .noresult {
            text-align: center;
            color: #B5B9BC;
            font-size: 12px;
            line-height: 18px;
            margin-top: 48px;
        }
    }

    .searchlists{
        position: relative;

        .bot_btn{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }

        li {
            &>.fl{
                display: flex;
                align-items: center;
                .name{
                    margin: 0;
                }
            }
        }
    }
</style>
<style>
    .el-dialog {
        border-radius: 6px;
    }

    .friendlist .el-dialog__header {
        display: none;
    }

    .friendlist .el-scrollbar__wrap {
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/friendsList.vue